import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsPaternFill from 'highcharts/modules/pattern-fill';
import { renderToString } from 'react-dom/server';
import {
  TooltipWrapper,
  TooltipHeader,
  TooltipRowTitle,
  TooltipRowValue,
  TooltipRow,
} from './PieChart.styles';
import { CHART_COLOR_PALLETTE } from 'utils/constants';

HighchartsPaternFill(Highcharts);

export interface IData {
  name: string;
  value: string;
  spend: string;
  isOther?: boolean;
  color?: any;
  y: number;
}

interface IProps {
  data: IData[];
  onHover: (s?: string) => void;
}

export const PieChart: React.FC<IProps> = ({ data, onHover }) => {
  const getOptions = () => {
    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        style: { fontFamily: 'Roboto' },
        width: 550,
        height: 432,
      },
      credits: { enabled: false },
      exporting: { enabled: false },
      title: { text: '' },
      series: [
        {
          innerSize: 155,
          size: 280,
          data,
        },
      ],
      plotOptions: {
        pie: {
          dataLabels: {
            connectorWidth: 1,
            connectorColor: CHART_COLOR_PALLETTE[1],
            connectorShape: 'straight',
            distance: 20,
          },
          borderWidth: 3,
        },
        series: {
          dataGrouping: {
            enabled: false,
          },
          animation: { duration: 400 },
          states: {
            inactive: { enabled: false },
            hover: {
              animation: { duration: 20 },
              halo: {
                size: 0,
              },
            },
          },
          point: {
            events: {
              mouseOver: function () {
                // @ts-ignore
                if (this && this.name) {
                  // @ts-ignore
                  const name = this.name;
                  setTimeout(() => {
                    onHover(name);
                  }, 20);
                }
              },
            },
          },
          events: {
            mouseOut: function () {
              setTimeout(() => {
                onHover();
              }, 20);
            },
          },
        },
      },
      tooltip: {
        useHTML: true,
        backgroundColor: 'white',
        borderWidth: 0,
        borderRadius: 2,
        outside: true,
        formatter: function () {
          // @ts-ignore
          const { point } = this as any;
          if (point.isOther) {
            return false;
          }

          return renderToString(
            <TooltipWrapper>
              <TooltipHeader>{point.name}</TooltipHeader>
              <TooltipRow>
                <TooltipRowTitle>of total</TooltipRowTitle>
                <TooltipRowValue>{point.value}</TooltipRowValue>
              </TooltipRow>
              <TooltipRow>
                <TooltipRowTitle>Spend value </TooltipRowTitle>
                <TooltipRowValue>{point.spend}</TooltipRowValue>
              </TooltipRow>
            </TooltipWrapper>
          );
        },
      },
    };
  };

  return <HighchartsReact highcharts={Highcharts} options={getOptions()} />;
};
